module.exports = __webpack_public_path__ + "img/pump_orange.ab6fee2a.svg";